/**
 * @module modules/alogin-sk
 * @description <h2><code>alogin-sk</code></h2>
 *
 * Handles logging into applications that use alogin.Login.
 *
 * @attr {boolean} testing_offline - If we should really fetch Login status or
 *  use mock data.
 *
 * @attr {string} url - The url that returns the JSON serialized alogin.Status response.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultStatusURL: function() {
        return defaultStatusURL;
    },
    resetLoggedInPromise: function() {
        return resetLoggedInPromise;
    },
    LoggedIn: function() {
        return LoggedIn;
    },
    AloginSk: function() {
        return AloginSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
const _json = require("../json");
const _url = require("../url");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const defaultStatusURL = '/_/login/status';
let loggedInPromise = null;
const resetLoggedInPromise = ()=>{
    loggedInPromise = null;
};
const LoggedIn = (url = defaultStatusURL)=>{
    if (loggedInPromise) {
        return loggedInPromise;
    }
    loggedInPromise = (async ()=>{
        try {
            const resp = await fetch(url);
            if (!resp.ok) {
                await (0, _errorMessage.errorMessage)(`Failed to load login status: ${resp.statusText}`);
                loggedInPromise = null; // Clear cache on error to allow retries.
                return defaultStatus;
            }
            return await resp.json();
        } catch (e) {
            loggedInPromise = null; // Clear cache on error to allow retries.
            throw e;
        }
    })();
    return loggedInPromise;
};
const defaultStatus = {
    email: '',
    roles: []
};
const fakeStatus = {
    email: 'test@example.com',
    roles: [
        'viewer'
    ]
};
let AloginSk = class AloginSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    async connectedCallback() {
        super.connectedCallback();
        const domain = (0, _url.rootDomain)();
        this.login = `https://${domain}/login/`;
        this.logout = `https://${domain}/logout/?redirect=${encodeURIComponent(window.location.origin)}`;
        if (this.testingOffline) {
            this.statusPromise = Promise.resolve(fakeStatus);
            this.status = fakeStatus;
        } else {
            this.statusPromise = LoggedIn(this.url || undefined);
            this.status = await this.statusPromise;
        }
    }
    render() {
        return (0, _lit.html)`
      <span class="email"> ${this.status.email} </span>
      <a class="logInOut" href="${this.status.email ? this.logout : this.login}">
        ${this.status.email ? 'Logout' : 'Login'}
      </a>
    `;
    }
    constructor(...args){
        super(...args);
        /**
   * A promise that resolves to the users logged in status.
   *
   * The value of this may be altered by the 'testing_offline' attribute.
   */ this.statusPromise = Promise.resolve(defaultStatus);
        this.testingOffline = false;
        this.url = '';
        this.login = '';
        this.logout = '';
        this.status = defaultStatus;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        attribute: 'testing_offline'
    }),
    _ts_metadata("design:type", Boolean)
], AloginSk.prototype, "testingOffline", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", String)
], AloginSk.prototype, "url", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof _json.Status === "undefined" ? Object : _json.Status)
], AloginSk.prototype, "status", void 0);
AloginSk = _ts_decorate([
    (0, _decorators.customElement)('alogin-sk')
], AloginSk);
